import Request from '../../request';
const BASE_URI_GO_API = process.env.API_GO_URL + '/api/v1';

const CreateReservation = async(solicitacaoId, data, listaEspera = false) => {
    return await Request.AxiosAuthPost(`${BASE_URI_GO_API}/reserva/criar/solicitacao/${solicitacaoId}`, {...data, listaEspera})
}

const CreateBoleto = async(reservaId, data) => {
    return await Request.AxiosAuthPost(`${BASE_URI_GO_API}/gerarBoleto/${reservaId}`, data)
}

const DeleteReservation = async(id,motivo) => {
    return await Request.AxiosAuthDelete(`${BASE_URI_GO_API}/reserva/cancelar/${id}`, motivo)
}

const CreateInvestDepositRecord = async(dados) => {
    return await Request.AxiosAuthPost(`${BASE_URI_GO_API}/reserva/criar/deposito`, dados)
}

const CreateInvestDebtRecord = async(dados) => {
    return await Request.AxiosAuthPost(`${BASE_URI_GO_API}/reserva/criar/debito`, dados)
}

export default { CreateReservation, CreateBoleto, DeleteReservation, CreateInvestDepositRecord, CreateInvestDebtRecord }






// WEBPACK FOOTER //
// ./src/services/api/investiment/index.js